export const featureList = [
    "Everything in Major",
    "Comprehensive Suite of Project Management Tools For Managing Assets",
    "Unlimited Storage & Organization For All File Types",
    "Organize Projects With Restricted Access To Essential Items",
    "Isolated Sandbox For Safe Creative Collaboration",
    "Streamlined Processes To Boost Productivity For Your Artists"
];

export const majorPlanFeatures = [
    "All the Features and Benefits of OmMuse Minor",
    "Upload & Store up to 500GB of high - quality audio and project files",
    "Social Media & Newsletter Promotion for Select Tracks",
    "Unlimited Encrypted Messaging with Collaborators and Fans"
];

export const minorPlanFeatures = [
    "Enjoy Our Robust Suite of AI-Based Music Organization Tools",
    "Upload & Store up to 100GB of Music Files, Stems, and Projects",
    "Share Tracks Publicly or Privately with Full Access Control",
    "Unlimited Encrypted Messaging with Other OmMuse Users",
    "Version Control: Update Tracks and Stems with Collaborators"
];

export const freePlanFeatures = [
    "Upload & store up to 5GB of music files, stems, and project files",
    "Basic AI-based music organization for easy cataloging",
    "Share tracks publicly or privately with full access control",
    "Profile & music featured on the Explore page for visibility",
    "Unlimited encrypted messaging with other OmMuse users",
    "Version control: update tracks and stems with collaborators",
    "Discover and collaborate with other artists through our user network",
    "Revenue dashboard & distribution to DSPs like Spotify (Coming Soon)",
];

export const studioPlanFeatures = [
    "1TB of Optimized Music & File Storage",
    "Advanced AI-Based Music Organization",
    "Tracks & NFTs Added to 'Featured Section'",
    "Profile, Tracks, & NFTs Highlighted on Website",
    "Social Media Promotion on OmMuse Socials",
    "Discounted Smart Contract Minting ($9.99/track)",
    "Shoutout on OmMuse Social Media Channels",
];

export const openMailToLink = (): void => {
    const mailtoLink = `mailto:hello@ommuse.com`;
    const newTab = window.open(mailtoLink);

    if (newTab && typeof newTab.focus === "function") {
        newTab.focus();
    } else {
        window.location.href = mailtoLink;
    }
};
